import React from 'react';
import { WarningCircleIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { appTranslate } from '../../i18n';

export const PortfolioModerationBadge = () => (
  <Button size="sm" intent="secondary" aria-label={appTranslate<string>('project_card.removed_badge')}>
    <WarningCircleIcon color="red_700" size="sm" />
    {appTranslate<string>('project_card.removed_badge')}
  </Button>
);
